const initialState = {
    anchor: 'left',
    home: [],
    fazendas: [],
    empresas: [],
    total_usuarios: 0,
    total_fazendas: 0,
    total_animais: 0,
    graficoTanques: {
        options: {},
        series: []
    },
    graficoAnimaisGrupos: {
        options: {},
        series: []
    },
    graficoDel: {
        options: {},
        series: [],
        media: 0
    },
    graficoDelMedioDias: {
        options: {},
        series: [],
        media: 0
    },
    graficoGorduraLeiteProteina: {
        options: {},
        series: []
    },
    graficoAnimaisAtivosPorPeriodo: {
        options: {},
        series: []
    },
    graficoIndicadoresTanques: {
        options: {},
        series: []
    },
    graficoGanhoPesoDesmame: {
        options: {},
        series: []
    },
    graficoIntervaloPartoConcepcao: {
        options: {},
        series: []
    },
    graficoDistribuicaoPartos: {
        options: {},
        series: []
    },
    graficoIdadePrimeiroParto: {
        options: {},
        series: []
    },
    graficoIntervaloPartos: {
        options: {},
        series: [],
        media: 0
    },
    graficoTaxaConcepcaoVacas: {
        options: {},
        series: [],
        media: 0
    },
    graficoTaxaConcepcaoTouros: {
        options: {},
        series: []
    },
    graficoTaxaConcepcaoInseminadores: {
        options: {},
        series: []
    },
    graficoIntervaloPartoAtePrimeiraInseminacao: {
        options: {},
        series: [],
        media: 0
    },
    graficoProducaoPorLote: {
        options: {},
        series: []
    },
    graficoProducaoPorDel: {
        options: {},
        series: [],
        media: 0
    },
    graficoProducaoNumeroPartos: {
        options: {},
        series: []
    },
    graficoTaxaPrenhez21DiasVacas: {
        options: {},
        series: [],
        media: 0
    },
    graficoTaxaPrenhez21DiasNovilhas: {
        options: {},
        series: [],
        media: 0
    },
    graficoTaxaInseminacao21DiasVacas: {
        options: {},
        series: [],
        media: 0
    },
    graficoTaxaInseminacao21DiasNovilhas: {
        options: {},
        series: [],
        media: 0
    },
    graficoTaxaConcepcao21DiasVacas: {
        options: {},
        series: [],
        media: 0
    },
    graficoTaxaConcepcao21DiasNovilhas: {
        options: {},
        series: [],
        media: 0
    }
};

export function home(state = initialState, action) {
    switch (action.type) {
        case 'FETCHED_HOME_REQUEST':
            return {
                ...state,
                isLoading: true
            }
        case 'HOME_DETAIL':
            return {
                ...state,
                fazendas: action.fazendas,
                empresas: action.empresas,
                total_usuarios: action.total_usuarios,
                total_fazendas: action.total_fazendas,
                total_animais: action.total_animais,
                graficoTanques: action.graficoTanques,
                graficoAnimaisGrupos: action.graficoAnimaisGrupos,
                graficoDistribuicaoPartos: action.graficoDistribuicaoPartos,
                graficoIdadePrimeiroParto: action.graficoIdadePrimeiroParto,
                graficoIntervaloPartos: action.graficoIntervaloPartos,
                graficoTaxaConcepcaoVacas: action.graficoTaxaConcepcaoVacas,
                graficoTaxaConcepcaoTouros: action.graficoTaxaConcepcaoTouros,
                graficoTaxaConcepcaoInseminadores: action.graficoTaxaConcepcaoInseminadores,
                graficoIntervaloPartoAtePrimeiraInseminacao: action.graficoIntervaloPartoAtePrimeiraInseminacao,
                graficoTaxaPrenhez21DiasVacas: action.graficoTaxaPrenhez21DiasVacas,
        graficoTaxaPrenhez21DiasNovilhas: action.graficoTaxaPrenhez21DiasNovilhas,
        graficoTaxaInseminacao21DiasVacas: action.graficoTaxaInseminacao21DiasVacas,
        graficoTaxaInseminacao21DiasNovilhas: action.graficoTaxaInseminacao21DiasNovilhas,
        graficoTaxaConcepcao21DiasVacas: action.graficoTaxaConcepcao21DiasVacas,
        graficoTaxaConcepcao21DiasNovilhas: action.graficoTaxaConcepcao21DiasNovilhas,
                graficoProducaoPorLote: action.graficoProducaoPorLote,
                graficoProducaoPorDel: action.graficoProducaoPorDel,
                graficoProducaoNumeroPartos: action.graficoProducaoNumeroPartos,
                graficoDel: action.graficoDel,
                graficoDelMedioDias: action.graficoDelMedioDias,
                graficoGorduraLeiteProteina: action.graficoGorduraLeiteProteina,
                graficoAnimaisAtivosPorPeriodo: action.graficoAnimaisAtivosPorPeriodo,
                graficoIndicadoresTanques: action.graficoIndicadoresTanques,
                graficoIntervaloPartoConcepcao: action.graficoIntervaloPartoConcepcao,
                graficoGanhoPesoDesmame: action.graficoGanhoPesoDesmame
            };
        case 'FETCHED_HOME_FAILURE':
            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        case 'FETCHED_HOME_SUCCESS':
            return {
                ...state,
                home: action.home,
                isLoading: false
            }
        default:
            return state
    }
}
